/*
 * Statutory guarantee notice dialog (snippets/guarantee-notice-dialog.liquid).
 *
 * - One dialog per page; triggers are found by delegation, so a cart drawer footer
 *   re-render (Section Rendering API replaces #CartDrawer-Footer) never loses the handler.
 * - The official artwork (the Commission's SVG, kept as a theme asset) is only requested
 *   when the dialog is first opened: it is ~600 KB and most shoppers never open it.
 * - The official wording is rendered server-side below it as a text alternative.
 * - If the image cannot be loaded the shopper gets a clear message, a retry, the text and
 *   the Your Europe link instead of a broken image. Nothing here touches the cart.
 */
(function () {
  'use strict';

  var dialog = document.querySelector('[data-guarantee-notice]');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';

  var img = dialog.querySelector('[data-guarantee-notice-img]');
  var figure = dialog.querySelector('[data-guarantee-notice-figure]');
  var loading = dialog.querySelector('[data-guarantee-notice-loading]');
  var error = dialog.querySelector('[data-guarantee-notice-error]');
  var body = dialog.querySelector('[data-guarantee-notice-body]');
  var LOAD_TIMEOUT = 12000;
  var opener = null;
  var state = 'idle'; // idle | loading | loaded | failed
  var attempts = 0;
  var timer = null;

  function settle(next) {
    window.clearTimeout(timer);
    state = next;
    loading.hidden = next !== 'loading';
    figure.hidden = next !== 'loaded';
    error.hidden = next !== 'failed';
    dialog.setAttribute('data-state', next);
  }

  function load() {
    if (state === 'loading' || state === 'loaded') return;
    var src = dialog.getAttribute('data-src');
    if (!src) return settle('failed');

    settle('loading');
    // Clearing src first makes the browser issue a fresh request for the same URL.
    if (attempts > 0) img.removeAttribute('src');
    attempts += 1;

    timer = window.setTimeout(function () {
      if (state === 'loading') {
        img.removeAttribute('src');
        settle('failed');
      }
    }, LOAD_TIMEOUT);
    img.src = src;
  }

  img.addEventListener('load', function () {
    // A 0x0 "image" means the server answered with something that is not the notice.
    settle(img.naturalWidth > 0 ? 'loaded' : 'failed');
  });
  img.addEventListener('error', function () {
    if (state === 'loading') settle('failed');
  });

  function open(trigger) {
    opener = trigger;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('guarantee-notice-open');
    body.scrollTop = 0;
    body.scrollLeft = 0;
    load();
  }

  function close() {
    if (typeof dialog.close === 'function') dialog.close();
    else {
      dialog.removeAttribute('open');
      onClose();
    }
  }

  function onClose() {
    document.documentElement.classList.remove('guarantee-notice-open');
    // The drawer footer may have re-rendered while the dialog was open; fall back to the live trigger.
    var target = opener && document.contains(opener) ? opener : document.querySelector('[data-guarantee-notice-open]');
    opener = null;
    if (target) target.focus();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-guarantee-notice-open]');
    if (trigger) {
      event.preventDefault();
      open(trigger);
      return;
    }
    if (!dialog.open) return;
    if (event.target.closest('[data-guarantee-notice-close]')) return close();
    if (event.target.closest('[data-guarantee-notice-retry]')) return load();
    // Click on the backdrop (the dialog element itself, outside its content box).
    if (event.target === dialog) close();
  });

  dialog.addEventListener('close', onClose);

  // Escape closes only this dialog. The dialog closes on keydown and focus returns to the
  // trigger inside the cart drawer, so the matching keyup would land there and close the
  // drawer too (cart-drawer.js closes on Escape keyup). Swallow exactly that one keyup.
  var swallowEscapeKeyup = false;
  dialog.addEventListener('keydown', function (event) {
    if (event.code === 'Escape') swallowEscapeKeyup = true;
  });
  document.addEventListener(
    'keyup',
    function (event) {
      if (event.code !== 'Escape' || !swallowEscapeKeyup) return;
      swallowEscapeKeyup = false;
      event.stopPropagation();
    },
    true
  );
})();
